<ion-header>
  <ion-toolbar>
    <ion-title>Noch nicht registriert?</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div class="inner-content p-6">
  <img src="/src/assets/img/undraw_secure_login_pdn4.svg" alt="Registrieren" class="w-full h-36 mt-3 mb-6"/>

  <div>
    Um diese Funktion nutzen zu können, musst du mit deinem Benutzer-Account in der App eingeloggt sein. Registriere
    dich jetzt und profitiere von allen Vorteilen.
  </div>
</div>

<ion-footer>
  <ion-toolbar class="ion-padding-horizontal">
    <ion-button expand="block" fill="solid" color="primary" class="cursor-pointer" (click)="navigateToRegisterPage()">
      Jetzt registrieren
    </ion-button>
  </ion-toolbar>
</ion-footer>
